import { Phone, MessageCircle } from "lucide-react";

const StickyActions = () => {
  return (
    <>
      {/* Sticky Call Button - Bottom Left */}
      <a 
        href="tel:+918217026707"
        className="fixed bottom-6 left-6 z-50 bg-gradient-to-r from-emerald-600 to-emerald-700 text-white p-4 rounded-full shadow-2xl hover:from-emerald-700 hover:to-emerald-800 transition-all duration-300 hover:scale-110 group"
        aria-label="Call us"
      >
        <Phone size={24} className="group-hover:rotate-12 transition-transform" />
      </a>

      {/* WhatsApp Floating Button - Bottom Right */}
      <a 
        href="https://wa.me/918217026707"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-green-500 to-green-600 text-white p-4 rounded-full shadow-2xl hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-110 animate-bounce"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle size={24} />
      </a>
    </>
  );
};

export default StickyActions;
